import { Router } from '@angular/router';
import { DataModel } from 'common/models/utility-models/base-model';
import { SystemService } from 'common/services/core-services/system.service';
import { FormWidgetService } from 'common/widget/form-widget.service';
import { BaseResolver } from './base-resolver';

export abstract class FormResolverService<T extends DataModel> extends BaseResolver<T> {
    protected constructor(
        protected ls: FormWidgetService<T>,
        protected override router: Router,
        protected systemService: SystemService
    ) {
        super(ls, router);
    }
}
